import React from "react";
import FormDetail from "features/appraisals/FormDetail";
import { clientRoutes } from "./clientRoutes";

// Admin Imports

import EmployeesLeaves from "pages/leaves/Leaves";
import EmployeeLeavesDetails from "pages/leaves/EmployeeLeavesDetails";
import LeaveDetail from "pages/leaves/LeaveDetail";
import CreateContract from "features/contracts/CreateContract";
import CreatePayslip from "pages/payslips/CreatePayslip";
import CreatePayslipBatch from "pages/payslips/CreatePayslipBatch";
import Payslip from "pages/payslips/Payslip";
import Payslips from "pages/payslips/Payslips";
import PayslipBatch from "pages/payslips/PayslipBatch";
import PayslipBatches from "pages/payslips/PayslipBatches";
import ResponseDetail from "features/appraisals/ResponseDetail";
import EditAppraisalForm from "features/appraisals/EditAppraisalForm";
import CreateQuestion from "features/appraisals/CreateQuestion";
import EditQuestion from "features/appraisals/EditQuestion";
import QuestionDetail from "features/appraisals/QuestionDetail";
import CreateAppraisalForm from "features/appraisals/CreateAppraisalForm";
import PolicyList from "pages/policy/PolicyList"; // adjust the path as needed
import CreateEmployeeUtilization from "pages/employee_utilization/CreateEmployeeUtilization";
import ManagerUtilizationsList from "pages/employee_utilization/ManagerUtilizationList";
import EmployeeUtilizationList from "pages/employee_utilization/EmployeeUtilizationList";
import WorkCategoryManagement from "pages/employee_utilization/CreateWorkCategory";
// Employee Imports
import Appraisals from "pages/appraisals/Appraisals";
import CreateTemplate from "pages/appraisals/CreateTemplate";
import EditTemplate from "pages/appraisals/EditTemplate";
import ViewTemplate from "pages/appraisals/ViewTemplate";
import CreateCycle from "pages/appraisals/CreateCycle";
import EditCycle from "pages/appraisals/EditCycle";
import ViewCycle from "pages/appraisals/ViewCycle";
import EmployeeAppraisals from "pages/employees/EmployeeAppraisals";
import FillEmployeeAppraisal from "pages/employees/FillEmployeeAppraisal";
import ViewEmployeeAppraisal from "pages/employees/ViewEmployeeAppraisal";
import ManagerAppraisals from "pages/managers/ManagerAppraisals";
import FillManagerAppraisal from "pages/managers/FillManagerAppraisal";
import ViewManagerAppraisal from "pages/managers/ViewManagerAppraisal";
import ManagerReviews from "pages/appraisals/ManagerReviews";
import ViewTeamMemberResponses from "pages/managers/ViewTeamMemberResponses";
import PeerNominations from "pages/managers/PeerNominations";
import ViewCycleReport from "pages/managers/ViewCycleReport";
import AppraisalForm from "pages/appraisals/AppraisalsForm";
import BioData from "pages/employees/BioData";
import EmployeePayslips from "pages/payslips/EmployeePayslips";
import EmployeeBioData from "pages/employees/EmployeeBioData";
import JobDetails from "pages/carrers/JobDetails";
import Carrers from "pages/carrers/Careers";
import EditJobDetails from "pages/carrers/EditJobDetails";
import JobApplication from "pages/carrers/JobApplication";
import Applicant from "pages/carrers/Applicants";
import CreateJobApplication from "features/carrers/CreateJobApplication";
import EditEmployeeBioData from "pages/employees/EditEmployeeBioData";
import LeaveInfoByType from "features/leaves/LeaveInfoByType";
import CreateHoliday from "pages/employees/CreateHoliday";
import CreateAnnouncement from "pages/employees/CreateAnnouncement";
import AllAnnouncements from "features/bulletin/AllAnnouncements";
import AllHolidays from "features/bulletin/AllHoliday";
import EmployeeLeavesSection from "features/leaves/EmployeeLeavesSection";


// Auth Imports
import SignIn from "pages/auth/SignIn";

// Icon Imports
import {
  MdBarChart,
  MdLock,
  MdFeedback,
  MdDescription,
  MdPayment,
  MdOutlinePerson,
  MdOutlinePages,
  MdGrading,
  MdContactPage,
  MdDashboard,
  MdPeople,
  MdNotifications,
  MdEditCalendar,
  MdQuestionMark,
  MdCorporateFare,
  MdPages,
  MdHandshake
} from "react-icons/md";

import PaySlipLineItemTypes from "pages/payslips/PayslipLineitemTypes";
import MyPayslips from "pages/payslips/MyPayslips";
import EmployeesList from "pages/employees/EmployeesList";
import EmployeesDetails from "pages/employees/EmployeeDetails";
import EmployeesProfile from "pages/employees/Profile";
import ShowContract from "pages/contracts/ShowContract";
import Home from "pages/auth/Home";

import MyContract from "pages/contracts/MyContract";
import CreatePolicy from "pages/policy/CreatePolicy";
import { useIsManager } from "app/hooks";
import AddDepartmentWizard from "features/organization_structure/AddDepartment";
import DepartmentDetail from "features/organization_structure/DepartmentDetail";
import { CreateLevelForm } from "features/organization_structure/CreateLevel";
import OrganizationChart from "pages/organization_structure/OrgChart";
import NotificationsPage from "pages/notifications/NotificationsPage";
import FullCalendarView from "pages/calendar/FullCalendarView";
import Admin from "layouts/main";
import ClientManagement from "pages/client_management/ClientManagement";
import CreateClient from "pages/client_management/CreateClient";
import ClientUserDetail from "pages/client_management/ClientUserDetail";
import QuestionManagement from "pages/first_test/QuestionManagement";
import TestWelcomeScreen from "features/first_test/WelcomeScreen";
import TestTakingScreen from "features/first_test/TestScreen";
import TestResultScreen from "features/first_test/TestResult";
import TestThankYouScreen from "features/first_test/TestThankYouScreen";

// Video Test Imports
import VideoWelcomeScreen from "features/video_test/VideoWelcomeScreen";
import VideoTestScreen from "features/video_test/VideoTestScreen";
import VideoThankYouScreen from "features/video_test/VideoThankYouScreen";
import VideoTestReviewList from "features/video_test/VideoTestReviewList";
import VideoTestReviewDetail from "features/video_test/VideoTestReviewDetail";
import GeneralQuestionnaireWelcomeScreen from "features/general_questionnaire/GeneralQuestionnaireWelcomeScreen";
import GeneralQuestionnaireScreen from "features/general_questionnaire/GeneralQuestionnaireScreen";
import GeneralQuestionnaireThankYouScreen from "features/general_questionnaire/GeneralQuestionnaireThankYouScreen";
import GeneralQuestionnaireReviewList from "features/general_questionnaire/GeneralQuestionnaireReviewList";
import GeneralQuestionnaireReviewDetail from "features/general_questionnaire/GeneralQuestionnaireReviewDetail";
import UnifiedTestFlow from "features/unified_test/UnifiedTestFlow";


// Client Management Changes Imports ft. Appraisal Module
import ManageClient from "./pages/client_management/ManageClient";

export const userRoutes: RoutesType[] = [
  {
    name: "Home",
    layout: "Main",
    icon: <MdOutlinePerson className="h-6 w-6" />,
    path: "/",
    display: false,
    permissions: ['employees.view_my_employee', 'client_management.view_my_client', 'client_management.view_my_clientuser'],
    component: <Home />,
  },
  {
    name: "Profile",
    layout: "Main",
    icon: <MdDashboard className="h-6 w-6" />,
    path: "/profile",
    display: true,
    permissions: ['employees.view_my_employee'],
    component: <EmployeesProfile />,
  },
  {
    name: "Notification",
    layout: "Main",
    icon: <MdNotifications className="h-6 w-6" />,
    path: "/notifications",
    display: false,
    permissions: ['employees.view_my_employee'],
    component: <NotificationsPage />
  },
  {
    name: "Create Department",
    layout: "Main",
    path: "/organization-structure/levels/departments",
    display: false,
    permissions: ['organization_structure.add_department'],
    component: <AddDepartmentWizard />,
  },
  {
    name: "Manage Department",
    layout: "Main",
    path: "/organization-structure/levels/departments/:departmentId",
    display: false,
    permissions: ['organization_structure.add_department'],
    component: <DepartmentDetail />,
  },
  {
    name: "Create Levels",
    layout: "Main",
    path: "/organization-structure/levels",
    display: false,
    permissions: ['organization_structure.add_level'],
    component: <CreateLevelForm />,
  },
  {
    name: "Create Holiday",
    layout: "Main",
    path: "/bulletin/holidays/create/",
    permissions: ['bulletin.add_holiday'], 
    component: <CreateHoliday />,
  },
  {
    name: "Create Announcement",
    layout: "Main",
    path: "/bulletin/announcements/create/",
    permissions: ['bulletin.add_announcement'],
    component: <CreateAnnouncement />,
  },
  {
    name: "All Announcements",
    layout: "Main",
    path: "/announcements/",
    permissions: ['bulletin.view_announcement'],
    component: <AllAnnouncements />,
  },
  {
    name: "All Holidays",
    layout: "Main",
    path: "/holidays/",
    permissions: ['bulletin.view_holiday'],
    component: <AllHolidays />,
  },
  {
    name: "Employee List",
    layout: "Main",
    icon: <MdOutlinePerson  className="h-6 w-6" />,
    path: "/all-employees",
    display: true,
    permissions: ['employees.view_employee'],
    component: <EmployeesList />,
  },
  {
    name: "Employee",
    layout: "Main",
    path: "/employee/:employeeId",
    display: false,
    permissions: ['employees.view_employee'],
    component: <EmployeesDetails />,
  },
  {
    name: "Edit Employee",
    layout: "Main",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "/employee/:employeeId/edit-bio-data",
    display: false,
    permissions:['employees.change_employee'],
    component: <EmployeeBioData />,
  },
  {
    name: "Careers",
    layout: "Main",
    path: "/careers",
    display: true,
    permissions:['careers.view_jobopening'],
    icon: <MdBarChart className="h-6 w-6" />,
    component: <Carrers />,
  },
  {
    name: "Job Description",
    layout: "Main",
    path: "/careers/job/:slug",
    display: false,
    permissions:['careers.view_jobopening'],
    component: <JobDetails />,
  },
  {
    name: "Edit Job Details",
    layout: "Main",
    path: "/careers/job/:slug/edit",
    display: false,
    permissions:['careers.view_jobopening'],
    component: <EditJobDetails />,
  },
  {
    name: "First Test Result",
    layout: "Main",
    path: "/careers/job-application/first-test-result/:testToken",
    display: false,
    permissions: ['careers.view_jobapplication'],
    component: <TestResultScreen />,
  },
  {
    name: "Video Test Review Detail",
    layout: "Main",
    path: "/careers/job-application/video-test-result/:testToken",
    display: false,
    permissions: ['careers.view_jobapplication'],
    component: <VideoTestReviewDetail />,
  },
  {
    name: "General Questionnaire Review Detail",
    layout: "Main",
    path: "/careers/job-application/general-questionnaire-result/:testToken",
    display: false,
    permissions: ['careers.view_jobapplication'],
    component: <GeneralQuestionnaireReviewDetail />,
  },
  {
    name: "Job Application",
    layout: "Main",
    path: "/careers/job-application/:jobId",
    display: false,
    permissions:['careers.view_jobopening'],
    component: <JobApplication />,
  },
  {
    name: "Applicant Details",
    layout: "Main",
    path: "/careers/applicant/:applicantId",
    display: false,
    permissions:['careers.view_jobopening'],
    component: <Applicant />,
  },  
  {
    name: "Create Job Application",
    layout: "Main",
    path: "/careers/create-job-application",
    display: false,
    permissions:['careers.add_jobapplication'],
    component: <CreateJobApplication />,
  },
  {
    name: "Edit Profile",
    layout: "Main",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "/edit-profile",
    display: false,
    permissions:['employees.change_my_employee'],
    component: <EditEmployeeBioData />,
  },
  {
    name: "Create Contract",
    layout: "Main",
    path: "/my-contract/create-contract",
    display: false,
    icon: <MdDescription className="h-6 w-6" />,
    permissions:["contracts.add_contract"],
    component: <CreateContract />,
  },
  {
    name: "Contract",
    layout: "Main",
    path: "/employee/contract/:contractId",
    display: false,
    permissions:["contracts.view_my_contract"],
    component: <ShowContract />,
  },
  {
    name: "My Contract",
    layout: "Main",
    path: "/my-contract",
    display: true,
    permissions:["contracts.view_my_contract"],
    icon: <MdContactPage className="h-6 w-6" />,
    component: <MyContract />,
  },
  {
    name: "Organization Overview",
    layout: "Main",
    path: "/organization-structure",
    display: true,
    permissions: ['employees.view_my_employee'],
    icon: <MdCorporateFare className="h-6 w-6" />,
    component: <OrganizationChart />,
  },
  {
    name: "Calendar",
    layout: "Main",
    path: "/calendar",
    display: false,
    permissions: ['leaves.view_employeeleavesdetails'],
    icon: <MdEditCalendar className="h-6 w-6" />,
    component: <FullCalendarView />,
  },
  // Test Routes
  {
    name: "Question Management",
    layout: "Main",
    path: "/careers/question-management",
    permissions: ['first_test.change_question'],
    display: false,
    component: <QuestionManagement />,
  },
  // Unified Test Flow - Single link for all tests
  {
    name: "Unified Test Flow",
    layout: "RecruitmentTest",
    path: "/unified-test/:testToken",
    display: false,
    component: <UnifiedTestFlow />,
  },
  {
    name: "Welcome",
    layout: "RecruitmentTest",
    path: "/test/welcome/:testToken",
    permissions: ['first_test.change_question'],
    display: false,
    component: <TestWelcomeScreen />,
  },
  {
    name: "Test",
    layout: "RecruitmentTest",
    path: "/test/:testToken",
    display: false,
    permissions: ['first_test.change_question'],
    component: <TestTakingScreen />,
  },
  {
    name:"Thank You",
    layout: "RecruitmentTest",
    path: "/test-thank-you/:testToken",
    display: false,
    component: <TestThankYouScreen />,
  },
  // Video Test Routes
  {
    name: "Video Test Welcome",
    layout: "RecruitmentTest",
    path: "/video-test/welcome/:testToken",
    display: false,
    component: <VideoWelcomeScreen />,
  },
  {
    name: "Video Test",
    layout: "RecruitmentTest",
    path: "/video-test/:testToken",
    display: false,
    component: <VideoTestScreen />,
  },
  {
    name: "Video Test Thank You",
    layout: "RecruitmentTest",
    path: "/video-test-thank-you/:testToken",
    display: false,
    component: <VideoThankYouScreen />,
  },
  {
    name: "Video Test Reviews",
    layout: "Main",
    path: "/video-test-reviews",
    display: false,
    permissions: ['careers.view_jobapplication'],
    icon: <MdBarChart className="h-6 w-6" />,
    component: <VideoTestReviewList />,
  },
  // General Questionnaire Routes
  {
    name: "General Questionnaire Welcome",
    layout: "RecruitmentTest",
    path: "/general-questionnaire/welcome/:testToken",
    display: false,
    component: <GeneralQuestionnaireWelcomeScreen />,
  },
  {
    name: "General Questionnaire",
    layout: "RecruitmentTest",
    path: "/general-questionnaire/:testToken",
    display: false,
    component: <GeneralQuestionnaireScreen />,
  },
  {
    name: "General Questionnaire Thank You",
    layout: "RecruitmentTest",
    path: "/general-questionnaire/thank-you/:testToken",
    display: false,
    component: <GeneralQuestionnaireThankYouScreen />,
  },
  {
    name: "General Questionnaire Reviews",
    layout: "Main",
    path: "/general-questionnaire-reviews",
    display: false,
    permissions: ['careers.view_jobapplication'],
    icon: <MdBarChart className="h-6 w-6" />,
    component: <GeneralQuestionnaireReviewList />,
  },
  //Client Management Routes
  {
    name: "Client Management",
    layout: "Main",
    path: "/client-management",
    display: true,
    permissions: ['client_management.view_clientuser'],
    icon: <MdPeople className="h-6 w-6" />,
    component: <ClientManagement />,
  },
  {
    name: "Create Client",
    layout: "Main",
    path: "/client-management/create",
    display: false,
    permissions: ['client_management.add_client'],
    component: <CreateClient />,
  },
  {
    name: "Client User Detail",
    layout: "Main",
    path: "/client-management/client-user/:clientUserId",
    display: false,
    permissions: ['client_management.view_clientuser'],
    component: <ClientUserDetail />,
  },
  {
    name: "Create Payslip",
    layout: "Main",
    path: "/payslip/create",
    permissions: ['payroll.add_payslip'],
    display: false,
    component: <CreatePayslip />,
  },
  {
    name: "Payslip",
    layout: "Main",
    path: "/payslip/:payslipId",
    permissions: ['payroll.view_payslip'],
    display: false,
    component: <Payslip />,
  },
  {
    name: "My Payslip",
    layout: "Main",
    path: "/my-payslip/:payslipId",
    permissions: ['payroll.view_my_payslip'],
    display: false,
    component: <Payslip />,
  },
  {
    name: "Payslips",
    layout: "Main",
    path: "/payslip",
    permissions: ['payroll.view_payslip'],
    display: true,
    icon: <MdPayment className="h-6 w-6" />,
    component: <Payslips />,
  },
  {
    name: "My Payslips",
    layout: "Main",
    path: "/my-payslip",
    permissions: ['payroll.view_my_payslip'],
    display: true,
    icon: <MdPayment className="h-6 w-6" />,
    component: <MyPayslips />,
  },
  {
    name: "Create Payslip Batch",
    layout: "Main",
    path: "/payslip/batch/create",
    permissions: ['payroll.add_payslipbatch'],
    display: false,
    icon: <MdLock className="h-6 w-6" />,
    component: <CreatePayslipBatch />,
  },
  {
    name: "Leave Type Detail",
    layout: "Main",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "/leaves/leavetype/:leaveTypeId/",
    display: false,
    permissions:['leaves.view_employeeleavesdetails'],
    component: <LeaveInfoByType />,
  },
  {
    name: "Leaves",
    layout: "Main",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "/leaves",
    display: true,
    permissions:["leaves.view_my_employeeleavesdetails"],
    component: <EmployeeLeavesDetails />,
  },
  {
    name: "Leave Details",
    layout: "Main",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "/leaves/:leaveId",
    display: false,
    permissions:['leaves.view_my_employeeleavesdetails','leaves.view_employeeleavesdetails', 'client_management.view_my_client', 'client_management.view_my_clientuser'],
    component: <LeaveDetail />,
  },
  {
    name: "Leave Detail",
    layout: "Leave",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "/leaves/leavedetails/:id/",
    display: false,
    permissions: ['leaves.view_employeeleavesdetails'],
    component: <LeaveInfoByType />,
  },
  {
    name: "Employee Leaves",
    layout: "Main",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "/leaves/employee/:employeeId",
    display: false,
    permissions: ['leaves.view_employeeleavesdetails'],
    component: <EmployeeLeavesSection />,
  },
  {
    name: "Bio Data",
    layout: "Main",
    icon: <MdOutlinePerson className="h-6 w-6" />,
    path: "/bio-data",
    display: false,
    permissions:['employees.add_my_employee'],
    component: <BioData />,
  },
  {
    name: "Payslip Line Item Types",
    layout: "Main",
    path: "/payslip/line-item-types",
    permissions: ['payroll.view_paysliplineitemtype', 'payroll.add_paysliplineitemtype'],
    display: false,
    icon: <MdLock className="h-6 w-6" />,
    component: <PaySlipLineItemTypes />,
  },
  {
    name: "Payslip Batches",
    layout: "Main",
    path: "/payslip/batch",
    permissions: ['payroll.view_payslipbatch'],
    display: false,
    icon: <MdLock className="h-6 w-6" />,
    component: <PayslipBatches />,
  },
  {
    name: "Payslip Batch",
    layout: "Main",
    path: "/payslip/batch/:batchId",
    permissions: ['payroll.view_payslipbatch'],
    display: false,
    icon: <MdLock className="h-6 w-6" />,
    component: <PayslipBatch />,
  },
  {
    name: "Batch Payslip",
    layout: "Main",
    path: "/payslip/batch/:batchId/:payslipId",
    permissions: ['payroll.view_payslip'],
    display: false,
    icon: <MdLock className="h-6 w-6" />,
    component: <Payslip />,
  },
  {
    name: "Payslips Employee",
    layout: "Main",
    path: "/payslip/emp/:employeeId",
    permissions: ['payroll.view_payslip'],
    display: false,
    icon: <MdLock className="h-6 w-6" />,
    component: <EmployeePayslips />,
  },
  {
    name: "Response",
    layout: "Main",
    path: "/employee/appraisal/response/:id",
    display: false,
    permissions: [
      "appraisals.view_appraisalresponse",
      "appraisals.view_answer",
    ],
    icon: <MdFeedback className="h-6 w-6" />,
    component: <ResponseDetail />,
  },
  {
    name: "Policies",
    layout: "Main",
    path: "/policy",
    display: true,
    permissions: ['policy.view_policy'],
    icon: <MdHandshake className="h-6 w-6" />,
    component: <PolicyList />,
  },
  {
    name: "Create Policy",
    layout: "Main",
    path: "/policy/create",
    permissions: ['policy.add_policy'],
    display: false,
    component: <CreatePolicy />,
  },
  {
    name: "Appraisals",
    layout: "Main",
    path: "/employee/appraisalforms",
    display: false,
    permissions:[
      "appraisals.add_appraisalresponse",
    ],
    icon: <MdFeedback className="h-6 w-6" />,
    component: <EmployeeAppraisals />,
  },
  {
    name: "Appraisal Form",
    layout: "Main",
    path: "/employee/appraisalforms/form/:appraisalId",
    display: false,
    permissions:[
      "appraisals.add_appraisalresponse",
    ],
    icon: <MdFeedback className="h-6 w-6" />,
    component: <AppraisalForm />,
  },
  {
    name: "Create Question",
    layout: "Main",
    path: "/admin-appraisals/question/create",
    display: false,
    permissions: [
      "appraisal_cycle.delete_appraisalcycle",
    ],
    icon: <MdFeedback className="h-6 w-6" />,
    component: <CreateQuestion />,
  },
  {
    name: "Edit Question",
    layout: "Main",
    path: "/question/edit/:id",
    display: false,
    permissions: [
      "appraisals.add_question", 
    ],
    icon: <MdFeedback className="h-6 w-6" />,
    component: <EditQuestion />,
  },
  {
    name: "Performance & Development",
    layout: "Main",
    path: "/admin-appraisals",
    display: true,
    permissions:[
      "appraisal_cycle.delete_appraisalcycle",
    ],
    icon: <MdGrading className="h-6 w-6" />,
    component: <Appraisals />,
  },
  {
    name: "Create Template",
    layout: "Main",
    path: "/admin-appraisals/templates/create",
    display: false,
    permissions: [
      "appraisal_cycle.delete_appraisalcycle",
    ],
    icon: <MdFeedback className="h-6 w-6" />,
    component: <CreateTemplate />,
  },
  {
    name: "Edit Template",
    layout: "Main",
    path: "/admin-appraisals/templates/:templateId/edit",
    display: false,
    permissions: [
      "appraisal_cycle.delete_appraisalcycle",
    ],
    icon: <MdFeedback className="h-6 w-6" />,
    component: <EditTemplate />,
  },
  {
    name: "View Template",
    layout: "Main",
    path: "/admin-appraisals/templates/:templateId/view",
    display: false,
    permissions: [
      "appraisal_cycle.delete_appraisalcycle",
    ],
    icon: <MdFeedback className="h-6 w-6" />,
    component: <ViewTemplate />,
  },
  {
    name: "Create Cycle",
    layout: "Main",
    path: "/admin-appraisals/cycles/create",
    display: false,
    permissions: [
      "appraisal_cycle.delete_appraisalcycle",
    ],
    icon: <MdFeedback className="h-6 w-6" />,
    component: <CreateCycle />,
  },
  {
    name: "Edit Cycle",
    layout: "Main",
    path: "/admin-appraisals/cycles/:cycleId/edit",
    display: false,
    permissions: [
      "appraisal_cycle.delete_appraisalcycle",
    ],
    icon: <MdFeedback className="h-6 w-6" />,
    component: <EditCycle />,
  },
  {
    name: "View Cycle",
    layout: "Main",
    path: "/admin-appraisals/cycles/:cycleId/view",
    display: false,
    permissions: [
      "appraisal_cycle.delete_appraisalcycle",
    ],
    icon: <MdFeedback className="h-6 w-6" />,
    component: <ViewCycle />,
  },
  {
    name: "Form",
    layout: "Main",
    path: "/admin-appraisals/form/:id",
    display: false,
    permissions: [
      "appraisal_cycle.delete_appraisalcycle",
    ],
    icon: <MdFeedback className="h-6 w-6" />,
    component: <FormDetail />,
  },
  {
    name: "Client Assignments",
    layout: "Main",
    path: "/client-management/:clientId",
    display: false,
    permissions: [
      "client_management.view_client" 
    ],
    icon: <MdFeedback className="h-6 w-6" />,
    component: <ManageClient />,
  },

  //question detail
  {
    name: "Question",
    layout: "Main",
    path: "/admin-appraisals/question/:id",
    display: false,
    permissions: [
      "appraisal_cycle.delete_appraisalcycle",
    ],
    icon: <MdFeedback className="h-6 w-6" />,
    component: <QuestionDetail />,
  },
  {
    name: "Form",
    layout: "Main",
    path: "/admin-appraisals/form/edit/:id",
    display: false,
    permissions: [
      "appraisal_cycle.delete_appraisalcycle",
    ],
    icon: <MdFeedback className="h-6 w-6" />,
    component: <EditAppraisalForm />,
  },
  {
    name: "create Form",
    layout: "Main",
    path: "/admin-appraisals/form/create",
    display: false,
    permissions: [
      "appraisal_cycle.delete_appraisalcycle",
    ],
    icon: <MdFeedback className="h-6 w-6" />,
    component: <CreateAppraisalForm />,
  },
  
  // Employee Utilization
  {
    name: "Add Employee Utilization",
    layout: "Main",
    path: "/employee-utilization/create/",
    display: false,
    permissions: [
      "employee_utilization.add_employeeutilization",
    ],
    icon: <MdFeedback className="h-6 w-6" />,
    component: <CreateEmployeeUtilization />,
  },
  {
    name: "Employee Utilization",
    layout: "Main",
    path: "/employee-utilization/",
    display: true,
    permissions: [
      "employee_utilization.view_my_employeeutilization",
    ],
    icon: <MdGrading className="h-6 w-6" />,
    component: <EmployeeUtilizationList />,
  },
  {
    name: "Manage Utilization",
    layout: "Main",
    path: "/employee-utilization/employees",

    display: false,
    permissions: [
      "employee_utilization.view_my_employeeutilization",
    ],
    icon: <MdGrading className="h-6 w-6" />,
    component: <ManagerUtilizationsList />,
  },
  {
    name: "Create Category",
    layout: "Main",
    path: "/employee-utilization/create-work-category/",
    display: false,
    permissions: [
      "employee_utilization.add_workcategory",
    ],
    icon: <MdGrading className="h-6 w-6" />,
    component: <WorkCategoryManagement />,
  },

  {
    name: "Performance & Development",
    layout: "Main",
    path: "/employee-appraisals",
    display: true,
    permissions: [
      "appraisal_response.view_appraisalresponse",
    ],
    excludePermissions: [
      "appraisals.add_appraisalform",
    ],
    icon: <MdGrading className="h-6 w-6" />,
    component: <EmployeeAppraisals />,
  },
  {
    name: "Fill Self Appraisal",
    layout: "Main",
    path: "/employee-appraisals/self/:cycleId",
    display: false,
    permissions: [
      "appraisal_response.add_appraisalresponse",
    ],
    component: <FillEmployeeAppraisal />,
  },
  {
    name: "Fill Peer Appraisal",
    layout: "Main",
    path: "/employee-appraisals/peer/:cycleId/employee/:employeeId",
    display: false,
    permissions: [
      "appraisal_response.add_appraisalresponse",
    ],
    component: <FillEmployeeAppraisal />,
  },
  {
    name: "View Employee Appraisal",
    layout: "Main",
    path: "/employee-appraisals/response/:responseId",
    display: false,
    permissions: [
      "appraisal_response.view_appraisalresponse",
    ],
    component: <ViewEmployeeAppraisal />,
  },

  {
    name: "Performance & Development",
    layout: "Main",
    path: "/manager-appraisals",
    display: true,
    permissions: [
      "appraisal_cycle.view_appraisalcycle",
    ],
    excludePermissions: [
      "appraisal_cycle.delete_appraisalcycle",
    ],
    icon: <MdGrading className="h-6 w-6" />,
    component: <ManagerAppraisals />,
  },
  {
    name: "Manager Reviews",
    layout: "Main",
    path: "/manager-reviews",
    display: false,
    permissions: [
      "appraisal_cycle.delete_appraisalcycle",
    ],
    icon: <MdGrading className="h-6 w-6" />,
    component: <ManagerReviews />,
  },
  {
    name: "Fill Manager Appraisal",
    layout: "Main",
    path: "/manager-appraisals/:cycleId/employee/:employeeId",
    display: false,
    permissions: [
      "appraisal_cycle.view_appraisalcycle",
    ],
    component: <FillManagerAppraisal />,
  },
  {
    name: "View Manager Appraisal",
    layout: "Main",
    path: "/manager-appraisals/response/:responseId",
    display: false,
    permissions: [
      "appraisal_cycle.view_appraisalcycle",
    ],
    component: <ViewManagerAppraisal />,
  },
  {
    name: "View Team Member Responses",
    layout: "Main",
    path: "/manager-appraisals/:cycleId/team-member/:employeeId",
    display: false,
    permissions: [
      "appraisal_cycle.view_appraisalcycle",
    ],
    component: <ViewTeamMemberResponses />,
  },
  {
    name: "Fill Manager Self Appraisal",
    layout: "Main",
    path: "/employee-appraisals/self/:cycleId", // Shared with employee self-path
    display: false,
    permissions: [
      "appraisal_cycle.view_appraisalcycle", // Manager permission
    ],
    component: <FillEmployeeAppraisal />,
  },
  {
    name: "Peer Nominations",
    layout: "Main",
    path: "/manager-appraisals/:cycleId/peer-nominations",
    display: false,
    permissions: [
      "appraisal_cycle.view_appraisalcycle",
    ],
    component: <PeerNominations />,
  },
  {
    name: "View Cycle Report",
    layout: "Main",
    path: "/manager-appraisals/:cycleId/report",
    display: false,
    permissions: [
      "appraisal_cycle.view_appraisalcycle",
    ],
    component: <ViewCycleReport />,
  },

];

export const authRoutes: RoutesType[] = [
  {
    name: "Sign In",
    layout: "Minimal",
    path: "/auth/sign-in",
    display: false, 
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
]

export const allRoutes: RoutesType[] = [...authRoutes,...userRoutes] ;

// Export clientRoutes separately
export { clientRoutes };